// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"f582595e","78":"575fa9cd","84":"dd295687","163":"53fef121","239":"23a953da","275":"f87129f5","441":"02661ed8","623":"8172969a","780":"d0a0e872"}[chunkId] + ".chunk.js";
};